import { AlertService } from './../alert/alert.service';
import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { AppConfig } from './../app-config';
import { User } from './User';

@Injectable()
export class AuthService {

  private _host: string;
  private _version: number;
  private userAuthentic: boolean = false;
  public emitAuth = new EventEmitter<boolean>();
  private _token:string;
  private user: User;
  private loga: number;

  constructor(
    private router: Router,
    private http: HttpClient,
    private alert: AlertService
  ) {
    this.getConfigApp();
  }

  public getToken() {
    return this._token;
  }

  public setToken(token:string) {
    this._token = token;
  }

  public authentic(usuario: User, method: string): Observable<any> {
    usuario.version = this._version;
    let data = this.formatData(usuario);

    return this.http.post(this._host + method, data, {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
      responseType: 'json'
    });
  }

  public signup(data: object, method: string): Observable<any> {
    return this.http.post(this._host + method, this.formatData(data), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
      responseType: 'json'
    })
  }

  public getData(data: any, method: string): Observable<object> {

    return this.http.get(this._host + method, {
      responseType: 'json',
      params: data
    });
  }

  public forgot(data: object, method: string): Observable<any> {
    return this.http.post(this._host + method, this.formatData(data), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
      responseType: 'json'
    })
  } 

  public checaCPF(token, cpf): Observable<any> {
    return this.http.get(this._host + `/api/mk/checa_cpf/${cpf}`, {
      responseType: 'json',
      params: {
        token: token
      }
    });
  }

  public linkaCadastro(token, id_mk): Observable<any> {
    return this.http.get(this._host + `/api/mk/linka_cadastro/${id_mk}`, {
      responseType: 'json',
      params: {
        token: token
      }
    });
  }

  /**
   * Converte objeto para urlencode
   * @param data
   */
  private formatData(data){
    
    return Object.keys(data).map(function(key){
      return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');
  }

  public getUser() {
    return this.user;
  }

  public setUser(data: User) {
    this.user = data;
  }

  public getUserAuthentic() {
    return this.userAuthentic;
  }

  public setUserAuthentic(auth: boolean) {
    this.userAuthentic = auth;
  }

  public setEmitAuth(value: boolean) {
    this.emitAuth.emit(value);
  }

  public getLoga() {
    return this.loga;
  }

  public setLoga(value: number) {
    this.loga = value;
  }

  public checkAuthUser(user: any, token: string): Observable<any> {
    return this.http.put(this._host + "/api/user/" + user.id, user, {
      params: {
        token: token
      }
    });
  }

  public getConfigApp() {
    let config = new AppConfig();
    this._host = config.app_host;
    this._version = config.minha_loga_version;
  }

}


// WEBPACK FOOTER //
// /Users/gmdimitriz/Projects/minha-loga/src/app/auth/auth.service.ts